import React, { useEffect } from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { colors } from '../../../utils/theme';
import RevealOnScroll from '../../../utils/RevealOnScroll';
import csscLogo from '../../../images/FeaturedProjects/CSSC/CSSC.png';
import { BsChevronDown } from 'react-icons/bs';

const ProjectContainer = styled.div`
  min-height: 100vh;
  padding: 2rem;
  background-color: ${colors.backgroundColor};
  color: ${colors.textColor};
`;

const HeaderSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 6rem 0;
  text-align: center;
`;

const Logo = styled.img`
  width: 400px;
  height: auto;
  
  @media (max-width: 768px) {
    width: 300px;
  }
`;

const Subtitle = styled.h2`
  font-size: clamp(1.2rem, 2vw, 1.5rem);
  color: ${colors.subtitleColor};
  margin-top: -3rem;
  font-family: "maitree", serif;
  max-width: 600px;
  text-align: left;
  font-weight: 400;
  
  @media (max-width: 768px) {
    margin-top: -1.5rem;
    padding: 0 1rem;
  }
`;

const ContentSection = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 2rem;
`;

const Description = styled.p`
  font-size: 1.4rem;
  line-height: 1.6;
  margin-bottom: 2rem;
  color: ${colors.subtitleColor};
`;

const InstagramFeed = styled.div`
  width: 100%;
  padding: 4rem 0;
  background-color: ${colors.backgroundColor};
  overflow: hidden;
`;

const InstagramGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
`;

const InstagramPost = styled.div`
  width: 100%;
  min-height: 400px;
  background: ${colors.backgroundColor};
  border-radius: 8px;
  overflow: hidden;

  iframe {
    width: 100% !important;
    margin: 0 !important;
  }
`;

const ArrowContainer = styled(motion.div)`
  color: white;
  opacity: 0.3;
  font-size: 1.5rem;
`;

const CSSC = () => {
  const instagramPosts = [
    'https://www.instagram.com/p/DFTR1uBymLc/?utm_source=ig_embed',
    "https://www.instagram.com/p/C4ZhfxZOn7K/",
    "https://www.instagram.com/p/C3Y7CeOgyrx/",
    "https://www.instagram.com/p/C2I25ARO9RK/",
    "https://www.instagram.com/p/CzfJkomuqG5/"
  ];

  useEffect(() => {
    // Load Instagram embed script
    const script = document.createElement('script');
    script.src = 'https://www.instagram.com/embed.js';
    script.async = true;
    document.body.appendChild(script);

    // Initialize embeds when script loads
    script.onload = () => {
      if (window.instgrm) {
        window.instgrm.Embeds.process();
      }
    };

    return () => {
      document.body.removeChild(script);
    };
  }, []); // Initial script load

  // Re-process embeds when posts change
  useEffect(() => {
    if (window.instgrm) {
      window.instgrm.Embeds.process();
    }
  }, [instagramPosts]);

  const arrowVariants = {
    animate: {
      y: [0, 10, 0],
      transition: {
        duration: 2,
        repeat: Infinity,
        ease: "easeInOut"
      }
    }
  };

  return (
    <ProjectContainer>
      <HeaderSection>
        <Logo src={csscLogo} alt="CSSC Logo" />
        <Subtitle>Building Community and Boosting Sales Through Engaging Content</Subtitle>
        <ArrowContainer
          variants={arrowVariants}
          animate="animate"
        >
          <BsChevronDown />
        </ArrowContainer>
      </HeaderSection>

      <InstagramFeed>
        <InstagramGrid>
          {instagramPosts.map((post, index) => (
            <RevealOnScroll key={index}>
              <InstagramPost>
                <blockquote
                  className="instagram-media"
                  data-instgrm-permalink={post}
                  data-instgrm-version="14"
                  style={{ 
                    background: '#FFF',
                    border: '0',
                    borderRadius: '3px',
                    boxShadow: 'none',
                    margin: '1px',
                    maxWidth: '540px',
                    minWidth: '326px',
                    padding: '0',
                    width: '99.375%'
                  }}
                />
              </InstagramPost>
            </RevealOnScroll>
          ))}
        </InstagramGrid>
      </InstagramFeed>

      <ContentSection>
        <RevealOnScroll>
          <Description>
          I directly lead and manage all content for sponsorships and brand collaborations, ensuring every piece aligns with our vision and strengthens our partnerships. Whether it’s a single sponsored post or a larger branded campaign, we create compelling video content that captures the energy of the club while staying true to our sponsors' guidelines. With over 600 active members, our content not only drives engagement but also reinforces community and the spaces where our members connect.          </Description>
        </RevealOnScroll>
      </ContentSection>
    </ProjectContainer>
  );
};

export default CSSC;
